/**
 * ScamBlocker AI — API Endpoint Sözleşmesi
 * Backend değişirse sadece bu dosya güncellenir.
 */

export const API = {
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://api.scamblockerai.app',

  org: {
    // Auth — backend mount: app.use('/api/org/auth', orgAuthRoutes)
    login: '/api/org/auth/login',
    register: '/api/org/auth/register',
    refresh: '/api/org/auth/refresh',
    logout: '/api/org/auth/logout',
    me: '/api/org/auth/me',
    wsToken: '/api/org/auth/ws-token', // canlı izleme WS için kısa ömürlü token

    // Portal — backend mount: app.use('/api/org', orgPortalRoutes)
    dashboard: '/api/org/dashboard',
    liveStream: '/api/org/live/stream', // SSE
    calls: '/api/org/calls',
    recordings: '/api/org/recordings',
    playRecord: (id: string) => `/api/org/recordings/${id}/play` as const,
    staff: '/api/org/staff',
    staffById: (id: string) => `/api/org/staff/${id}` as const,
    members: '/api/org/members',
    memberById: (id: string) => `/api/org/members/${id}` as const,
    apiKeys: '/api/org/api-keys',
    revokeKey: (id: string) => `/api/org/api-keys/${id}/revoke` as const,
    webhooks: '/api/org/webhooks',
    webhookById: (id: string) => `/api/org/webhooks/${id}` as const,
    webhookPing: (id: string) => `/api/org/webhooks/${id}/ping` as const,
    branded: '/api/org/branded-numbers',
    brandedById: (id: string) => `/api/org/branded-numbers/${id}` as const,
    settings: '/api/org/settings',
    billing: '/api/org/billing',
    audit: '/api/org/audit',
    reportWeekly: '/api/org/reports/weekly',
    reportExport: '/api/org/reports/export',
    students: '/api/org/students', // GET (liste) + POST (batch enrollment) aynı yol
    extraMemberRequest: '/api/org/extra-member-request',
  },

  b2b: {
    provision: '/api/b2b/provision',
    bulkCheck: '/api/b2b/bulk-check',
    verifyCall: '/api/b2b/verify-call',
    stats: '/api/b2b/stats',
  },
} as const;
